// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Pricing Page Glass Styles
   ========================================== */

.pricing-page {
  min-height: 100vh;
  padding: 2rem 1.5rem 4rem 1.5rem;
  text-align: center;
}

.title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #ffffff;
}

.subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 4rem;
}

.pricing-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
}

.plan {
  background: var(--bg-glass-card);
  border: 1px solid var(--border-glass);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-lg);
  padding: 3rem 2rem;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: var(--shadow-lg);
}

.plan:hover {
  transform: translateY(-8px);
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
}

.badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: var(--grad-primary);
  color: #fff;
  font-size: 0.75rem;
  padding: 0.35rem 1rem;
  border-radius: var(--radius-full);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.plan h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
}

.price {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 2rem;
}

.price span {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-muted);
}

.plan ul {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  text-align: left;
}

.plan li {
  font-size: 0.95rem;
  padding: 0.75rem 0;
  color: var(--text-muted);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
}

.plan li::before {
  content: "\\2713";
  color: var(--color-emerald);
  margin-right: 0.75rem;
  font-weight: bold;
}

.choose-btn {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: var(--radius-md);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.choose-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.plan.popular {
  border: 1px solid var(--color-primary);
  transform: scale(1.05);
  background: var(--grad-surface);
}

.plan.popular:hover {
  transform: scale(1.05) translateY(-8px);
}

.plan.popular .choose-btn {
  background: var(--grad-primary);
  border: none;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.plan.popular .choose-btn:hover {
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}

@media (max-width: 768px) {
  .plan.popular {
    transform: scale(1);
  }
  .plan.popular:hover {
    transform: translateY(-8px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pricing.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Pricing Page Glass Styles\n   ========================================== */\n\n.pricing-page {\n  min-height: 100vh;\n  padding: 2rem 1.5rem 4rem 1.5rem;\n  text-align: center;\n}\n\n.title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  color: #ffffff;\n}\n\n.subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 4rem;\n}\n\n.pricing-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  justify-content: center;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.plan {\n  background: var(--bg-glass-card);\n  border: 1px solid var(--border-glass);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-lg);\n  padding: 3rem 2rem;\n  transition: all 0.3s ease;\n  position: relative;\n  box-shadow: var(--shadow-lg);\n}\n\n.plan:hover {\n  transform: translateY(-8px);\n  border-color: rgba(245, 158, 11, 0.4);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);\n}\n\n.badge {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: var(--grad-primary);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 0.35rem 1rem;\n  border-radius: var(--radius-full);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.plan h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.price {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 2rem;\n}\n\n.price span {\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.plan ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem 0;\n  text-align: left;\n}\n\n.plan li {\n  font-size: 0.95rem;\n  padding: 0.75rem 0;\n  color: var(--text-muted);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  align-items: center;\n}\n\n.plan li::before {\n  content: \"\\2713\";\n  color: var(--color-emerald);\n  margin-right: 0.75rem;\n  font-weight: bold;\n}\n\n.choose-btn {\n  width: 100%;\n  padding: 1rem;\n  border: none;\n  border-radius: var(--radius-md);\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.choose-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.plan.popular {\n  border: 1px solid var(--color-primary);\n  transform: scale(1.05);\n  background: var(--grad-surface);\n}\n\n.plan.popular:hover {\n  transform: scale(1.05) translateY(-8px);\n}\n\n.plan.popular .choose-btn {\n  background: var(--grad-primary);\n  border: none;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n.plan.popular .choose-btn:hover {\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);\n}\n\n@media (max-width: 768px) {\n  .plan.popular {\n    transform: scale(1);\n  }\n  .plan.popular:hover {\n    transform: translateY(-8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
